enum LocalStorageKey {
  VERSION_UPDATED = 'versionUpdated',
  PURCHASED_TIME_AND_ATTENDANCE = 'purchasedTimeAndAttendance',
  SHOULD_USE_NEW_EMPLOYER_ONBOARDING = 'shouldUseNewEmployerOnboarding',
}

export default LocalStorageKey;
